export default {"src":"/_next/static/media/24hr-transfers.938a9db1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};